'use strict';

const _=require('pulsar-utils/dist-es6/_');
const d3=require('d3');
const Guid=require('pulsar-utils/dist-es6/domain/guid');
const Formatters=require('../../../../dist-es6/client/formatters');
const StatisticsPanelHelpers=require('../../../../dist-es6/client/directives/statisticsPanels/statisticsPanelHelpers');
const BaseControllerBackedDirective=require('../../../../dist-es6/client/angularCommon/baseControllerBackedDirective');let

BaseStatisticsPanelDirective=class BaseStatisticsPanelDirective extends BaseControllerBackedDirective{
get controller(){return BaseStatisticsPanelDirectiveController}
get objectBindings(){return['dimensions']}
get textBindings(){return['title','subtitle']}
get templateUrl(){
return'/templates/directives/statisticsPanels/baseStatisticsPanelTemplate';
}

factory(){
let directive=super.factory();
directive.transclude=!0;
directive.replace=!0;
return directive;
}};let


BaseStatisticsPanelDirectiveController=class BaseStatisticsPanelDirectiveController{
constructor($scope,$element,$timeout,elementService){
this._$scope=$scope;
this._$element=$element;
this._$timeout=$timeout;
this._elementService=elementService;

this._debouncedUpdateStyles=_.debounce(()=>this._$timeout(()=>this._updateStyles()),25);
this._$scope.$on('resize::resize',()=>this._debouncedUpdateStyles());
this._debouncedUpdateStyles();
}

get panelBodyChildren(){
return this._panelBodyChildren||(this._panelBodyChildren=this._elementService.selectElement(this._$element).find('.panel-body').children());
}

_updateStyles(){
const panelBodyChildren=this.panelBodyChildren;

if(panelBodyChildren.length!==2){
throw new Error('StatisticsPanel body must contain exactly two top-level elements');
}

const[leftElement,rightElement]=panelBodyChildren;
const subComponentDimensions=StatisticsPanelHelpers.getSubComponentDimensionsFrom(this.dimensions);

angular.element(panelBodyChildren[0]).attr('style',`width: ${subComponentDimensions.left.width}px !important; height: ${subComponentDimensions.left.height}px !important;`);
angular.element(panelBodyChildren[1]).attr('style',`width: ${subComponentDimensions.right.width}px !important; height: ${subComponentDimensions.right.height}px !important;`);
}};


module.exports=BaseStatisticsPanelDirective;
//# sourceMappingURL=baseStatisticsPanelDirective.js.map
